/* Independent, progressively enhanced product carousel; no theme-library dependency. */
if (!customElements.get('hsk-pucks-carousel')) {
  customElements.define('hsk-pucks-carousel', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.scrollFrame);
      if (this.events) this.events.abort();
      if (this.observer) this.observer.disconnect();
    }
    setup() {
      if (!this.isConnected) return;
      this.track = this.querySelector('[data-pucks-track]');
      this.cards = Array.from(this.querySelectorAll('[data-pucks-card]'));
      this.controls = this.querySelector('[data-pucks-controls]');
      if (!this.track || !this.cards.length || !this.controls) return;
      if (this.events) this.events.abort();
      if (this.observer) this.observer.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.prev = this.querySelector('[data-pucks-prev]');
      this.next = this.querySelector('[data-pucks-next]');
      this.status = this.querySelector('[data-pucks-status]');
      this.track.id = this.id.replace('hsk-pucks-', 'hsk-pucks-track-');
      this.controls.hidden = false;
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : (this.track.scrollWidth - this.track.clientWidth) * (rtl ? -1 : 1), behavior: this.behavior() });
        }
      }, options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), options);
      }
      this.update();
    }
    behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const style = getComputedStyle(this.track);
      const step = this.cards[0].getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.track.scrollBy({ left: step * direction * (style.direction === 'rtl' ? -1 : 1), behavior: this.behavior() });
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.prev.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, i) => {
        const rect = card.getBoundingClientRect();
        const overlap = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left);
        return overlap >= Math.min(rect.width, bounds.width) * 0.55 ? i + 1 : 0;
      }).filter(Boolean);
      if (visible.length) {
        const range = visible.length > 1 ? visible[0] + '–' + visible[visible.length - 1] : String(visible[0]);
        const label = range + ' / ' + this.cards.length;
        if (this.status.textContent !== label) this.status.textContent = label;
      }
    }
  });
}
